<div
  class="drag-and-drop-area p-5"
  vitamuiCommonDragAndDrop
  [enableFolderDragAndDrop]="true"
  (fileToUploadEmitter)="handleFilesSelection($event)"
  [class.error]="hasErrors()"
>
  <input
    #fileSelector
    type="file"
    (change)="handleFilesSelection($event.target.files)"
    [accept]="extensions?.join(',')"
    [multiple]="multiple"
  />
  @if (directoryMode) {
    <input #directorySelector type="file" (change)="handleFilesSelection($event.target.files)" [multiple]="multiple" webkitdirectory />
  }

  <div class="gap-2 align-items-stretch">
    @if (content) {
      <ng-container *ngTemplateOutlet="content"></ng-container>
    } @else {
      <ng-container *ngTemplateOutlet="defaultContent"></ng-container>
    }

    @if (fileList) {
      <ng-container *ngTemplateOutlet="fileList"></ng-container>
    } @else {
      <ng-container *ngTemplateOutlet="defaultFileList"></ng-container>
    }
  </div>
</div>

<vitamui-form-errors [control]="control"></vitamui-form-errors>

<ng-template #defaultFileList>
  @if (displayFiles.length) {
    <div class="files-wrapper gap-2 align-items-stretch">
      @for (file of displayFiles; track file) {
        <vitamui-display-file [file]="file" (removeFile)="removeFile($event)" [errorMessageMap]="errorMessageMap"></vitamui-display-file>
      }
    </div>
  }
</ng-template>

<ng-template #defaultContent>
  @if (displayMessageAndLinks) {
    <div class="align-items-stretch gap-2">
      <div class="text large bold text-center primary" [class.danger]="hasErrors()">
        <div>{{ 'FILE_SELECTOR.DRAG_AND_DROP' | translate }}</div>
        @if (directoryMode) {
          <div>{{ 'FILE_SELECTOR.OR' | translate }}</div>
          <div class="d-flex row justify-content-center">
            <div class="text bold link primary" [class.danger]="hasErrors()" (click)="openDirectorySelectorOSDialog()">
              {{ 'FILE_SELECTOR.BROWSE_DIRECTORIES' | translate }}
            </div>
            <div class="ml-2 mr-2">/</div>
            <div class="text bold link primary" [class.danger]="hasErrors()" (click)="openFileSelectorOSDialog()">
              {{ 'FILE_SELECTOR.BROWSE_FILES' | translate }}
            </div>
          </div>
        } @else {
          <div class="d-flex row justify-content-center">
            <div class="mr-2">{{ 'FILE_SELECTOR.OR' | translate }}</div>
            <div class="text bold link primary" [class.danger]="hasErrors()" (click)="openFileSelectorOSDialog()">
              {{ 'FILE_SELECTOR.BROWSE' | translate }}
            </div>
          </div>
        }
      </div>

      @if (extensions || maxSizeInBytes || information) {
        <div class="text normal text-center vitamui-grey-600">
          @if (extensions) {
            <div>
              {{ extensions.length | i18nPlural: format | translate: { formats: extensions.join(', ') } }}
            </div>
          }
          @if (maxSizeInBytes) {
            <div>
              {{ 'FILE_SELECTOR.MAX_SIZE' | translate: { size: maxSizeInBytes | bytes: 0 } }}
            </div>
          }
          @if (information) {
            @for (info of information; track info) {
              <div>
                {{ info }}
              </div>
            }
          }
        </div>
      }
    </div>
  }
</ng-template>
